import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import { escapeElement } from "./escape-element";
/**
 * Represents an XML text value.
 */

var XmlText =
/** @class */
function () {
  function XmlText(value) {
    this.value = value;
  }

  XmlText.prototype.toString = function () {
    return escapeElement("" + this.value);
  };

  return XmlText;
}();

export { XmlText };